import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { Upload, Image as ImageIcon, X } from 'lucide-react';
interface FileUploadProps {
  label: string;
  accept?: string;
  onUpload?: (file: File) => void;
  accentColor?: 'cyan' | 'purple';
}
export function FileUpload({
  label,
  accept = 'image/*',
  onUpload,
  accentColor = 'cyan'
}: FileUploadProps) {
  const [preview, setPreview] = useState<string | null>(null);
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const handleFile = (file: File) => {
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result as string);
      };
      reader.readAsDataURL(file);
      onUpload?.(file);
    }
  };
  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFile(e.dataTransfer.files[0]);
    }
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      handleFile(e.target.files[0]);
    }
  };
  const removeFile = (e: React.MouseEvent) => {
    e.stopPropagation();
    setPreview(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };
  const activeBorder = accentColor === 'cyan' ? 'border-cyan-500 bg-cyan-500/5' : 'border-purple-500 bg-purple-500/5';
  const iconColor = accentColor === 'cyan' ? 'text-cyan-500' : 'text-purple-500';
  return <div className="mb-6" data-id="element-187">
      <label className="block text-sm font-medium text-slate-300 mb-3" data-id="element-188">
        {label}
      </label>

      <div onClick={() => fileInputRef.current?.click()} onDragOver={e => {
      e.preventDefault();
      setIsDragging(true);
    }} onDragLeave={() => setIsDragging(false)} onDrop={handleDrop} className={`relative w-full h-48 rounded-xl border-2 border-dashed transition-all cursor-pointer flex flex-col items-center justify-center overflow-hidden group ${isDragging ? activeBorder : 'border-slate-700 hover:border-slate-500 bg-slate-800/50'}`} data-id="element-189">
        <input ref={fileInputRef} type="file" accept={accept} onChange={handleChange} className="hidden" data-id="element-190" />

        {preview ? <div className="relative w-full h-full" data-id="element-191">
            <img src={preview} alt="Preview" className="w-full h-full object-cover" data-id="element-192" />
            <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center" data-id="element-193">
              <button onClick={removeFile} className="p-2 bg-rose-500 rounded-full text-white hover:bg-rose-600 transition-colors" data-id="element-194">
                <X size={20} data-id="element-195" />
              </button>
            </div>
          </div> : <div className="text-center p-6" data-id="element-196">
            <div className={`w-12 h-12 rounded-full bg-slate-800 flex items-center justify-center mx-auto mb-4 ${isDragging ? iconColor : 'text-slate-400'}`} data-id="element-197">
              {isDragging ? <Upload size={24} data-id="element-198" /> : <ImageIcon size={24} data-id="element-199" />}
            </div>
            <p className="text-sm text-slate-300 font-medium mb-1" data-id="element-200">
              Drop your image here or click to browse
            </p>
            <p className="text-xs text-slate-500" data-id="element-201">
              Supports JPG, PNG, WEBP (Max 5MB)
            </p>
          </div>}
      </div>
    </div>;
}